import { useBaseApiQuery } from "@query/baseQuery";

export const usePostsQuery = (page) => {
    return useBaseApiQuery(
        { endpoint: `/organization/me/post/page/${page}` }, 
        { queryKey: ["posts", page] }
    );
};

export const usePostQuery = (postUuid, refetchOnWindowFocus) => {
    return useBaseApiQuery(
        { endpoint: `/post/${postUuid}` }, 
        { queryKey: ["post", postUuid], enabled: !!postUuid, refetchOnWindowFocus: refetchOnWindowFocus }
    );
};